import { useState } from 'react'
import { T } from '@/lib/theme'

/// Collapsible Q&A, one open at a time.
///
/// `items`: `[{ q, a }]` where `a` is a string or a node. Content lives in a per-surface data file
/// (see src/lib/faqContent.js), never inline in the page component - the questions are prose that
/// wants editing without touching layout, and inlining them is how the same explanation ends up
/// written twice with two different answers.
export function FaqAccordion({ items }) {
  const [open, setOpen] = useState(null)
  if (!items || items.length === 0) return null

  return (
    <div>
      {items.map((it, i) => {
        const isOpen = open === i
        return (
          <div key={it.q} style={{ borderBottom: `1px solid ${T.border}` }}>
            <button
              onClick={() => setOpen(isOpen ? null : i)}
              aria-expanded={isOpen}
              style={questionBtn}
            >
              <span style={{
                display: 'inline-block', width: 12, flexShrink: 0, color: T.textDim,
                transform: isOpen ? 'rotate(0deg)' : 'rotate(-90deg)', transition: 'transform 0.15s ease',
              }}>
                ⌄
              </span>
              <span style={{ flex: 1 }}>{it.q}</span>
            </button>
            {isOpen && (
              <div style={answerStyle}>
                {it.a}
              </div>
            )}
          </div>
        )
      })}
    </div>
  )
}

const questionBtn = {
  display: 'flex', alignItems: 'center', gap: 10, width: '100%', textAlign: 'left',
  padding: '16px 4px', background: 'none', border: 'none', cursor: 'pointer',
  color: T.text, fontFamily: T.fontM, fontSize: T.fs.ui, fontWeight: 700,
}
const answerStyle = {
  padding: '0 4px 18px 26px', color: T.textMuted, fontFamily: T.fontM,
  fontSize: T.fs.body, lineHeight: 1.7, maxWidth: 720,
}
